import { atom, useAtomValue, useSetAtom } from 'jotai';

type CategoryValue = string;

const currentCategoryValue = atom<CategoryValue>('');

export const useCurrentCategoryValue = () => {
  return useAtomValue(currentCategoryValue);
};

export const useSetCurrentCategoryValue = () => {
  return useSetAtom(currentCategoryValue);
};

export const useResetCategoryValue = () => {
  const setCurrentResponse = useSetAtom(currentCategoryValue);
  return () => setCurrentResponse('');
};
